import { type MessageKey, t } from '../../i18n';
import { type CostEstimate, formatMoney } from './data';

/** Costo estimado de las licencias de un alta, línea por línea (guía 7.5). */
export function CostEstimateTable({ estimate }: { estimate: CostEstimate }) {
  return (
    <div className="space-y-2 text-sm">
      <ul className="space-y-1" aria-label={t('us.costo_estimado')}>
        {estimate.lines.map((l) => (
          <li key={l.licenseTypeId} className="flex flex-wrap justify-between gap-2">
            <span className="text-slate-800">
              {l.name} <span className="text-xs text-slate-500">· {t(`us.costo_${l.reason}` as MessageKey)}</span>
            </span>
            <span className="tabular-nums text-slate-700">
              {l.monthly > 0 ? t('us.por_mes', { monto: formatMoney(l.monthly) }) : l.upfront > 0 ? formatMoney(l.upfront) : t('us.sin_costo')}
            </span>
          </li>
        ))}
      </ul>
      <p className="border-t border-slate-200 pt-2 font-medium text-slate-900">
        {t('us.costo_total', { mensual: formatMoney(estimate.monthly), inicial: formatMoney(estimate.upfront) })}
      </p>
    </div>
  );
}
